import { api } from "./apiSlice";

interface ApiResponse<T> {
  success: boolean;
  data: T;
}

export interface TransitRecord {
  id: string;
  transitStatus: string;
  receiverHospitalId: string;
  dispatchDateTime: string;
  deliveryDateTime: string;
  deliveryVehicle: string;
  bloodRequestId: string | null;
  bloodId: string;
  bloodBankId: string | null;
}

export interface CreateTransitInput {
  bloodId: string;
  receiverHospitalId: string;
  deliveryVehicle: string;
  dispatchDateTime?: string;
  deliveryDateTime: string;
  transitStatus?: string;
  bloodBankId?: string;
  bloodRequestId?: string;
}

export const bloodTransitApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getTransitRequests: builder.query<{ transits: TransitRecord[]; requests: unknown[] }, { bloodBankId?: string; hospitalId?: string }>({
      query: ({ bloodBankId, hospitalId }) => {
        const params = new URLSearchParams();
        if (bloodBankId) params.set("bloodBankId", bloodBankId);
        if (hospitalId) params.set("hospitalId", hospitalId);
        return `/blood-bank/transit-requests?${params.toString()}`;
      },
      transformResponse: (res: ApiResponse<{ transits: TransitRecord[]; requests: unknown[] }>) => res.data,
    }),
    createTransit: builder.mutation<TransitRecord, CreateTransitInput>({
      query: (body) => ({ url: "/blood-bank/transits", method: "POST", body }),
      transformResponse: (res: ApiResponse<TransitRecord>) => res.data,
    }),
  }),
});

export const { useGetTransitRequestsQuery, useCreateTransitMutation } = bloodTransitApi;
